import { cn } from '@eliadmin/core/src/utils/style-utils';

/** SveTech placeholder: #f2f3ef with the square top-right corner, pulses only without reduced motion. */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-[12px] rounded-tr-none bg-[#f2f3ef] motion-safe:animate-pulse',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
